const getIosBridge = () => {
  var _webkit;
  return (_webkit = window.webkit) === null || _webkit === void 0 || (_webkit = _webkit.messageHandlers) === null || _webkit === void 0 ? void 0 : _webkit.firebase;
};
const getAndroidBridge = () => window.AnalyticsWebInterface;
export const isInAppWebView = () => {
  var _getIosBridge;
  return Boolean((_getIosBridge = getIosBridge()) !== null && _getIosBridge !== void 0 ? _getIosBridge : getAndroidBridge());
};
export const logFirebaseEvent = (name, parameters = {}) => {
  var _getAndroidBridge;
  const iosBridge = getIosBridge();
  if (iosBridge) {
    iosBridge.postMessage({
      command: 'logEvent',
      name,
      parameters
    });
    return;
  }
  (_getAndroidBridge = getAndroidBridge()) === null || _getAndroidBridge === void 0 || _getAndroidBridge.logEvent(name, JSON.stringify(parameters));
};
//# sourceMappingURL=webViewBridge.js.map